const titles = {
  platforms: 'Platforms',
  released: 'Release Date',
  genres: 'Genres',
  metacritic: 'Metascore',
  developers: 'Developed by',
  playtime: 'Playtime (hours)',
  tags: 'Tags'
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  titles
}